import { IBackendSettingsService } from "../services/BackendSettingsService";
import { CelebrationType, SpeedType } from "./api";
import { ChangeSpeedParams } from "./slot/SlotGameType1";
import { PopUpSettings } from "./slot/panel/PopUpSettings";

const SpeedFactor = 2200;
const SpeedFactorForSpine = 1;
export interface SpeedManagerParams
{
    backendSettings: IBackendSettingsService
}
export const speedTypeMap:Record<number, SpeedType> =
{
    1: SpeedType.Type1,
    2: SpeedType.Type2,
    3: SpeedType.Type3,
}
export const speedTypeMapInverted:Record<SpeedType, number> =
{
    [SpeedType.Type1]:1,
    [SpeedType.Type2]:2,
    [SpeedType.Type3]:3,
}
export const ChangeSpeedFactor: Record<CelebrationType, number>=
{
    [CelebrationType.Fast]:SpeedFactor*0.50,
    [CelebrationType.Normal]: SpeedFactor,
    [CelebrationType.Slow]:SpeedFactor*1.25
}


// (celebType: CelebrationType) : number {
//     // let SpeedFactor = 2200;
    

//     if (celebType == CelebrationType.Fast) {
//         return SpeedFactor * 0.50;
//     }
//     else if (celebType == CelebrationType.Normal) {
//         return SpeedFactor ;
//     }
//     else if (celebType == CelebrationType.Slow) {
//         return SpeedFactor * 1.25;
//     }

//     //console.log(`SymbolType-${symbolsType}`, SpeedFactor);

//     return SpeedFactor;

// }

export interface SpinAnimParams
{
    SpeedFactor: number,
    Duration: number,
    Delay: number,
    SpeedCorrection: number
}

export const availableSpinParams: Record<SpeedType, SpinAnimParams> = {

    //Slow
    [SpeedType.Type1]:
    {
        SpeedFactor: 1,
        Duration: 0,
        Delay: 400,
        SpeedCorrection:0.90 * 0.30
    },

    //Normal
    [SpeedType.Type2]:
    {
        SpeedFactor: 1,
        Duration: 0,
        Delay: 350,
        SpeedCorrection:0.90 * 0.50
    },

    //Fast
    [SpeedType.Type3]: 
    {
        SpeedFactor:1,
        Duration:0,
        Delay:0,
        SpeedCorrection:0.65 * 0.65   
    }
};

export const ChangeSpeedSpine: Record<CelebrationType, number> =
{
    [CelebrationType.Fast]:SpeedFactorForSpine*1.25,
    [CelebrationType.Normal]: SpeedFactorForSpine,
    [CelebrationType.Slow]:SpeedFactorForSpine*0.85

}
// export function ChangeSpeedSpine(celebType: CelebrationType) : number {
//     let SpeedFactor = 1;
    

//     if (celebType == CelebrationType.Fast) {
//         return SpeedFactor * 1.25;
//     }
//     else if (celebType == CelebrationType.Normal) {
//         return SpeedFactor ;
//     }
//     else if (celebType == CelebrationType.Slow) {
//         return SpeedFactor * 0.85;
//     }   

//     return SpeedFactor;
    
// }

export const celebrationTypeMap: Record<SpeedType, CelebrationType> = 
{
    "Type1":CelebrationType.Slow,
    "Type2":CelebrationType.Normal,
    "Type3":CelebrationType.Fast,
}

export class SpeedManager 
{

    // protected allowToChange: boolean = false;
    protected speedLevel: number;
    protected backendSettings: IBackendSettingsService;

    protected reset: boolean = false;

    public constructor()
    {

    }

    protected defaultSpeedCelebration: CelebrationType;
    protected defaultSpeedReelsType: SpeedType;
    protected defaultSpeedLevel: number;
    protected selectedSpeedLevel: number;


    public Load(backendSettings: IBackendSettingsService)
    {
        this.backendSettings = backendSettings;
        this.defaultSpeedCelebration = this.backendSettings?.GetEnum<CelebrationType>('play.celebration',CelebrationType.Slow) ?? CelebrationType.Slow;
        this.defaultSpeedReelsType = this.backendSettings?.GetEnum<SpeedType>("play.speedtype", SpeedType.Type1) ?? SpeedType.Type1;

        this.defaultSpeedLevel = this.GetSpeedLevel(this.defaultSpeedReelsType)
    }

    public GetDefaultSpeedLevel(): number
    {
        return this.defaultSpeedLevel;
    }

    public GetDefaultReelSpeedType():SpeedType
    {
        return this.defaultSpeedReelsType;
    }
    public GetDefaultCelebrationType(): CelebrationType
	{
        return this.defaultSpeedCelebration;
	}
    protected GetSpeedLevel(speedType: SpeedType): number
    {
        return speedTypeMapInverted[speedType]
    }
    public SetSelectedSpeedLevel(speedLevel: number)
    {
        this.selectedSpeedLevel = speedLevel;
    }

    public ResetToDefault()
    {
        if (this.speedLevel != this.defaultSpeedLevel)
        {
            this.speedLevel =this.defaultSpeedLevel;   
        }
    }
    protected speedParams: ChangeSpeedParams ={
        SpinParams: null,
        CelebrationFactor: null,
        SymbolSpeedAnimationSpine: null,
    }

    protected popUpSettingsArray: PopUpSettings[] = []

    public CreateUpdateList(popUpMenuAnim: PopUpSettings)
    {
        this.popUpSettingsArray.push(popUpMenuAnim);
    }
    public SetSpeed()
    {
        let speedType = speedTypeMap[this.selectedSpeedLevel ?? this.defaultSpeedLevel];
        let celebType = celebrationTypeMap[speedType]

        this.speedParams.SpinParams = availableSpinParams[speedType];
        this.speedParams.CelebrationFactor = ChangeSpeedFactor[celebType];
        this.speedParams.SymbolSpeedAnimationSpine = ChangeSpeedSpine[celebType];

        this.popUpSettingsArray.forEach(element => {
            element.OnSpeedChanged?.(this.speedParams);
            element.UpdateSpeedIcon(this.selectedSpeedLevel ?? this.defaultSpeedLevel)
        });

    }
}

export type SpeedChangedCallback = (speed: ChangeSpeedParams) => void;
